import React from "react";
import BackgroundTitle from "../../components/ui/BackgroundTitle";
import Doctor from "../../components/ui/cards/Doctor";
import FaqService from "../../components/ui/cards/FaqService";
import Testimonials from "../../components/ui/cards/Testimonials";
import { IoIosPlay } from "react-icons/io";

function About() {
  return (
    <div className='overflow-hidden'>
      <div>
        <BackgroundTitle title='ABOUT US' />
      </div>
      <div className='px-5 sm:px-0 grid grid-cols-1 sm:grid-cols-2 gap-5 sm:gap-24 items-center'>
        <div className='relative'>
          <img
            src={require("../../assets/about/2.webp")}
            alt='thumb'
            className='object-cover pt-5 sm:pt-0'
          />
          <div className='p-5 bg-primary rounded-full text-center absolute bottom-[40%] -right-14 hover:cursor-pointer opacity-0 sm:opacity-100'>
            <IoIosPlay size={70} fill='white' />
          </div>
        </div>
        <div>
          <div className='w-[95%] sm:w-[75%]'>
            <h1 className='text-2xl sm:text-3xl text-black/80'>
              Welcome to Remedic Hospital since 1898 established Far far away.
            </h1>
            <p className='leading-loose text-gray-500 mt-6'>
              Far far away, behind the word mountains, far from the countries
              Vokalia and Consonantia, there live the blind texts. Separated
              they live in Bookmarksgrove right at the coast of the Semantics, a
              large language ocean.
            </p>
            <p className='leading-loose text-gray-500 mt-4'>
              A small river named Duden flows by their place and supplies it
              with the necessary regelialia. It is a paradisematic country, in
              which roasted parts of sentences fly into your mouth.
            </p>
          </div>
        </div>
      </div>
      <div className='px-5 sm:px-7 lg:px-14 xl:px-48 py-28'>
        {/* OUR EXPERIENCED DOCTORS */}
        <div>
          <h1 className='uppercase text-center mb-20 text-2xl sm:text-3xl text-gray-700'>
            OUR EXPERIENCED DOCTORS
          </h1>
          <div className='flex justify-center items-center'>
            <div className='grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-10 sm:gap-14'>
              <Doctor
                title='Dr. John Doe'
                dic='Cardiologist'
                pic={require("../../assets/doctors/1.webp")}
              />
              <Doctor
                title='Aldin Powell'
                dic='Neurologist'
                pic={require("../../assets/doctors/2.webp")}
              />
              <Doctor
                title='Aldin Powell'
                dic='Pediatrician'
                pic={require("../../assets/doctors/3.webp")}
              />
              <Doctor
                title='Aldin Powell'
                dic='Pulmonologist'
                pic={require("../../assets/doctors/4.webp")}
              />
            </div>
          </div>
          <div className='mt-14 w-[95%] sm:w-[80%]'>
            <h1 className='text-2xl mb-2.5 text-black/70'>
              We are well experienced doctors
            </h1>
            <p className='text-gray-500 leading-loose'>
              A small river named Duden flows by their place and supplies it
              with the necessary regelialia. It is a paradisematic country, in
              which roasted parts of sentences fly into your mouth.
            </p>
          </div>
        </div>
      </div>
      <div className='bg-faq bg-no-repeat bg-cover h-screen sm:h-[95vh] lg:h-[80.5vh] xl:h-[70.5vh] w-full overflow-hidden'>
        <div>
          <div>
            <FaqService
              title='Laboratory Services'
              disc='Even the all-powerful Pointing has no control about the blind.'
            />
            <FaqService
              title='General Treatment'
              disc='Even the all-powerful Pointing has no control about the blind.'
            />
            <FaqService
              title='Emergency Service'
              disc='Even the all-powerful Pointing has no control about the blind.'
            />
            <FaqService
              title='24/7 Help & Support'
              disc='Even the all-powerful Pointing has no control about the blind.'
            />
          </div>
        </div>
      </div>
      {/* SOME FUN FACTS */}
      <div>
        <div className='bg-facts bg-no-repeat bg-cover relative h-screen sm:h-[78vh] w-full'>
          <div className='absolute inset-0 flex justify-center items-center bg-white/10'>
            <div className='text-white text-center'>
              <h1 className='uppercase text-3xl'>SOME FUN FACTS</h1>
              <p className='my-10'>
                Far far away, behind the word mountains, far from the countries
              </p>
              <div className='grid grid-cols-1 sm:grid-cols-4 gap-14 sm:gap-32 lg:gap-40 xl:gap-44 mt-14'>
                <div>
                  <h1 className='text-4xl sm:text-5xl'>60</h1>
                  <p className='text-sm text-white/90 mt-4'>Hospital</p>
                </div>
                <div>
                  <h1 className='text-4xl sm:text-5xl'>200</h1>
                  <p className='text-sm text-white/90 mt-4'>Doctors</p>
                </div>
                <div>
                  <h1 className='text-4xl sm:text-5xl'>100</h1>
                  <p className='text-sm text-white/90 mt-4'>Clinics</p>
                </div>
                <div>
                  <h1 className='text-4xl sm:text-5xl'>200</h1>
                  <p className='text-sm text-white/90 mt-4'>Reviews</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='px-5 sm:px-7 lg:px-14 xl:px-48 py-28'>
        <h1 className='uppercase text-center mb-20 text-2xl sm:text-3xl text-gray-700'>
          TESTIMONIALS
        </h1>
        <div className='flex justify-center'>
          <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 items-center gap-20'>
            <Testimonials
              pic={require("../../assets/testimonials/1.webp")}
              name='Dennis Green'
              dic='Patient'
            />
            <Testimonials
              pic={require("../../assets/testimonials/3.webp")}
              name='Dennis Green'
              dic='Doctor'
            />
            <Testimonials
              pic={require("../../assets/testimonials/2.webp")}
              name='Dennis Green'
              dic='Patient'
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
